import { useContext, useEffect, useState } from "react";
import { SettingsContext, ShopContext, UserContext } from "../../App";
import Api from "../api/api";
import Moment from "react-moment";
import "moment-timezone";
import "moment/locale/it";
import OrderSheet from "./OrderSheet";
import Label from "../Label";
import { getStatusLabel, textLabel } from "../functions/functions";
import SearchIcon from "../../icons/SearchIcon";

function Orders() {
	const { setLoading, labels, lang } = useContext(SettingsContext);
	const { user } = useContext(UserContext);
	const { brand, shop } = useContext(ShopContext);
	const [orders, setOrders] = useState([]);
	const [order, setOrder] = useState(false);
	const [page, setPage] = useState(1);
	const [pagination, setPagination] = useState({
		pag: 1,
		total_pages: 1,
		total_records: 0,
	});

	useEffect(() => {
		loadOrders(page);
	}, [page, brand, user?.id]);

	const loadOrders = async (currentPage = 1) => {
		if (!user?.id) return;
		setLoading(true);
		let request = {
			src: [{ name: "customer_id", value: user.id, compare: "equal" }],
			orderby: "id DESC",
			pag: currentPage,
			per_pag: 10,
		};
		if (brand) {
			request.src.push({ name: "brand_id", value: brand.id, compare: "equal" });
		}
		const res = await Api.postProtected("/orders/list/", request);
		setLoading(false);
		console.log(res);
		setOrders(res.rows);
		if (res.pagination) setPagination(res.pagination);
	};

	const loadBillUrl = async (selectedOrder) => {
		if (shop?.scloby_active == 1) {
			setLoading(true);
			const response = await Api.postProtected("/orders/get_bill_url/" + selectedOrder.id + "/");
			setLoading(false);
			if (response.success == 0) {
				alert(response.error);
				return;
			}
			window.open(response.bill_url, "_blank");
			return;
		}

		setLoading(true);
		const response = await Api.postProtected("/orders/get/" + selectedOrder.id + "/");
		setLoading(false);
		if (response.success == 0) {
			alert(response.error);
			return;
		}
		const billUrl = typeof response.data?.bill_url === "string" ? response.data.bill_url.trim() : "";
		if (!billUrl) {
			alert(textLabel(labels, 173, lang) || "Scontrino non disponibile");
			return;
		}
		window.open(billUrl, "_blank");
	};

	const canShowReceiptButton = (selectedOrder) =>
		selectedOrder.erecipt == 2 || shop?.scloby_active == 1;

	return (
		<>
			{!order ? (
				<div className="verticalContainer">
					<div className="title">
						<Label number={76} />
					</div>
					<div className="scrollContent">
						{orders.length == 0 ? (
							<div className="text-center"><Label number={174} /></div>
						) : (
							orders.map((order, i) => (
								<div key={i}>
									<div className="d-flex justify-content-between align-items-center">
										<div>
											<div className="bold">
												<Label number={175} /> {order.number ? `N.${order.number} - ` : ""}ID:{order.id}
											</div>
											<div className="small">
												<Moment format={"DD/MM/YYYY LT"} locale="it">
													{order.delivery_date}
												</Moment>
											</div>
										</div>
										<div>
											<Label number={getStatusLabel(order.status)} />
										</div>
										<div className="small user-orders-actions">
											{canShowReceiptButton(order) && (
												<button
													className="basic-button"
													onClick={() => loadBillUrl(order)}
												>
													<Label number={171} />
							</button>
											)}
											<button
												className="basic-button"
												onClick={() => setOrder(order)}
											>
												<SearchIcon></SearchIcon>
											</button>
										</div>
									</div>
									<hr />
								</div>
							))
						)}
						{pagination.total_pages > 1 && (
							<div className="d-flex justify-content-between align-items-center mt-3">
								<button
									className="basic-button"
									disabled={page <= 1}
									onClick={() => setPage((prev) => prev - 1)}
								>
									<Label number={180} />
								</button>
								<div className="small text-center">
									<Label number={183} /> {page} <Label number={184} /> {pagination.total_pages}
								</div>
								<button
									className="basic-button"
									disabled={page >= pagination.total_pages}
									onClick={() => setPage((prev) => prev + 1)}
								>
									<Label number={181} />
								</button>
							</div>
						)}
					</div>
				</div>
			) : (
				<OrderSheet
					order={order}
					setOrder={setOrder}
					loadBillUrl={loadBillUrl}
					showReceiptButton={canShowReceiptButton(order)}
				/>
			)}
		</>
	);
}

export default Orders;
